import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {MODALS_IDS} from '@Components/modal-container';

/**
 * Opens the confirmation a canceled subscriber sees before restarting. The plan they asked for travels with it so
 * that "Change plan" lands on that plan rather than the one they are already on. Lives beside the component rather
 * than in it so that file exports only its component, which is what lets react-refresh keep its boundary.
 */
export const openResubscribeConfirmationModal = (preselectLevel?: number, preselectDuration?: number): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.RESUBSCRIBE_CONFIRMATION_MODAL,
      panelProps: {preselectLevel, preselectDuration},
    })
  );
};
